<template>
  <v-container fluid class="mx-1" v-if="languageData.labels">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card class="operationsCard py-7" v-if="layout === 'edit'">
      <v-btn class="ml-5" style="color: #fff; display: flex; align-items: center; justify-content: center;" @click="createTimeReport" color="primary">
        {{ languageData.create_time_report }} 
        <span v-on:click.stop @click="openGuidesModal('issueHourlyRaport')" class="guides-question-mark" style="background-color: #fff; color: #FFA400;">?</span>
        </v-btn>
      <v-btn class="ml-5" style="color: #fff" @click="createInvoice" color="primary">
        {{ languageData.create_invoice }}
        <span v-on:click.stop @click="openGuidesModal(['billAZ', 'finalSettlement'])" class="guides-question-mark" style="background-color: #fff; color: #FFA400;">?</span>
        </v-btn>
      <v-tooltip top :disabled="!disableCreateMeasurement">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn class="ml-5" style="color: #fff" @click="createMeasurement" color="primary" :disabled="disableCreateMeasurement">{{ languageData.measurements.create_measurement }}</v-btn>
        </div>  
      </template>
      <span>{{ languageData.measurements.tooltip }}</span>
    </v-tooltip>
    </v-card>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header class="autoheight">
              <div class="py-5 pl-5 mr-3" v-if="!isOffer">
                <BackButton />
              </div>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ languageData.sectionProject.basicInformation }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :complete="e1 > 2" @click="setStep(2)" step="2">{{ languageData.sectionProject.description }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :complete="e1 > 3" @click="setStep(3)" step="3">{{ languageData.sectionProject.address }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="!isOffer" :complete="e1 > 4" @click="setStep(4)" step="4">{{ languageData.sectionProject.clients }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :complete="e1 > 5" @click="setStep(5)" step="5">{{ languageData.sectionProject.additionalInfo }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step  :complete="e1 > 6" @click="setStep(6)" step="6">{{ languageData.sectionProject.invoicePayments }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :ref="layout !== 'edit' ? 'lastStep' : null" v-if="!isOffer" :complete="e1 > 7" @click="setStep(7)" step="7">{{ languageData.estimation }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout === 'edit'" :complete="e1 > 8" @click="setStep(8)" step="8">{{ languageData.sectionProject.notes }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout === 'edit'" :complete="e1 > 9" @click="setStep(9)" step="9">{{ languageData.sectionProject.documents }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :ref="layout === 'edit' ? 'lastStep' : null" v-if="layout === 'edit'" :complete="e1 > 10" @click="setStep(10)" step="10">{{ languageData.sectionProject.tasks }}</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formP" v-model="validP" @hook:mounted="handleForm('formP')">
                        <p class="text-h5 mb-7">{{ languageData.sectionProject.basicInformation }}</p>
                        <v-row>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                              :label="languageData.labels.project_name"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.project_name"
                              v-model="data.name"
                              :rules="rules.name"
                              name="name"
                              >
                            </v-text-field>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                           <v-menu
                            ref="menuStart"
                            v-model="menuStart"
                            :close-on-content-click="false"
                            :return-value.sync="activePickerStart"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.start_date"
                                    v-model="data.start_date"
                                    :label="languageData.labels.start_date"
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="data.start_date"
                                  no-title
                                  scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menuStart = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menuStart.save(data.menuStart)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-menu
                            ref="menuEnd"
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            :return-value.sync="activePickerEnd"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.end_date"
                                    v-model="data.end_date"
                                    :label="languageData.labels.end_date"
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="data.end_date"
                                  no-title
                                  scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menuEnd = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menuEnd.save(data.menuEnd)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col v-if="isVatPayer === 'true'" :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-select
                                v-if="isVatPayer === 'true'"
                                :label="languageData.labels.vat_settlement"
                                height="55px"
                                outlined
                                v-model="data.vat_settlement"
                                :items="vatsSettlement"
                                :disabled="layout === 'edit'" 
                                item-value="value"
                                item-text="name"
                                return-object>
                              <template slot='selection' slot-scope='{ item }'>
                                {{ languageData.vatSettlementSelect[item.value]  }}
                              </template>
                              <template slot='item' slot-scope='{ item }'>
                                {{ languageData.vatSettlementSelect[item.value]  }}
                              </template>
                            </v-select>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? isVatPayer === 'true' ?  4 : 6 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.net_value"
                                :label="languageData.labels.net_value"
                                v-model="data.net_value"
                                @change="setNetPositive"
                                append-icon="euro">
                            </v-text-field>
                          </v-col>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? isVatPayer === 'true' ?  4 : 6 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.construction_number"
                                :label="languageData.labels.construction_number"
                                v-model="data.construction_number">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end">
                    <v-btn
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(2)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formR" v-model="validR" @hook:mounted="handleForm('formR')">
                        <p class="text-h5 mb-7">{{ languageData.sectionProject.description }}</p>
                        <v-textarea
                            class="pt-1 mb-4"
                            :label="languageData.labels.short_description"
                            rows="6"
                            outlined
                            hide-details
                            v-model="data.short_description"></v-textarea>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-4">
                    <v-btn
                        class="button-shadow mr-4"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(1)">
                      {{ languageData.back }}
                    </v-btn>
                    <v-btn
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(3)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formS" v-model="validS" @hook:mounted="handleForm('formS')">
                        <p class="text-h5 mb-7">{{ languageData.sectionProject.address }}</p>
                        <v-row>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12"
                            >
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.street"
                                :label="languageData.labels.street"
                                v-model="data.address.street"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.building_number"
                                :label="languageData.labels.building_number"
                                v-model="data.address.building_number">
                            </v-text-field>
                          </v-col>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.flat_number"
                                :label="languageData.labels.flat_number"
                                v-model="data.address.flat_number"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.postal_code"
                                :label="languageData.labels.postal_code"
                                v-model="data.address.postal_code">
                            </v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.city"
                                :label="languageData.labels.city"
                                v-model="data.address.city">
                            </v-text-field>
                          </v-col>
                          <v-col
                            v-if="countries.length > 0"
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-select
                              v-model="data.address.country_id"
                              :items="countries"
                              :label="languageData.labels.country"
                              outlined
                              item-value="id"
                              item-text="name"
                              height="55px"
                          >
                            <template slot='selection' slot-scope='{ item }'>
                              {{ item.name }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                              {{ item.name }}
                            </template>
                          </v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-4">
                    <v-btn
                        class="button-shadow mr-4"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(2)">
                      {{ languageData.back }}
                    </v-btn>
                    <v-btn
                        v-if ="!isOffer"
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(4)">
                      {{ languageData.next }}
                    </v-btn>
                    <v-btn
                        v-else-if ="isOffer"
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(5)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="4">
                  <v-row justify="center">
                    <v-col cols="12" ref="formT" v-model="validT">
                      <v-form>
                        <p class="text-h5 mb-7">{{ languageData.sectionProject.clients }}</p>
                        <template v-if="isOffer">
                          <ClientsTableStatic :layout="layout" :clients="offerData.clients" :clientsTypes="offerData.clientsTypes"></ClientsTableStatic>
                        </template>
                        <template v-else-if="!isOffer || layout !== 'editModal'">
                          <ClientsTableForm :layout="layout" :clients="data.clients" :clientsTypes="selectedId"></ClientsTableForm>
                        </template>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(3)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(5)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-content step="5">
                <v-card elevation="0">
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formU" v-model="validU" @hook:mounted="handleForm('formU')">
                        <p class="text-h5 mb-7">{{ languageData.sectionProject.additionalInfo }}</p>
                        <v-row>
                          <v-col :cols="12">
                            <div>
                              <p class="slider-label">{{ languageData.labels.hourlyRate }}</p>
                              <v-text-field
                                type="number"
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.employee_hour"
                                @keypress="isNumber($event)"
                                v-model="data.employee_hour"
                                @change="fixedValue(1)"
                                :label="languageData.labels.employee_hour"
                                append-icon="euro">
                              </v-text-field>
                            </div>                   
                          </v-col>
                        </v-row>
                        <v-row>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      v-if="!isOffer"
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(4)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      v-else-if="isOffer"
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(3)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(6)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-content step="6">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form>
                        <div>
                          <v-btn
                              color="primary"
                              @click="addPayment"
                          >
                            {{ languageData.invoicePayments.addPayment }}
                          </v-btn>
                        </div>
                        <div v-if="invoicePaymentsData.length > 0">
                          <div v-for="payment in invoicePaymentsData" :key="payment.name">
                            <v-row class="mt-5" style="align-items: center">
                              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                                <v-select
                                    outlined
                                    :label="languageData.invoicePayments.days"
                                    :items="daysArray"
                                    v-model="payment.days"
                                    hide-details
                                >
                                </v-select>
                              </v-col>
                              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                                <span class="slider-label">{{ languageData.labels.discount }}</span>
                                <v-slider
                                    :min="0"
                                    :max="100"
                                    :step="1"
                                    color="#5670B6"
                                    track-color="#5670B6"
                                    height="50"
                                    width="20px"
                                    v-model="payment.discount"
                                >
                                  <template v-slot:prepend class="rangeNumber">
                                    <p>0</p>
                                  </template>
                                  <template v-slot:append class="rangeNumber">
                                    100
                                  </template>
                                </v-slider>
                              </v-col>
                              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                                <div style="display: flex">
                                  <div :style="$vuetify.breakpoint.mdAndUp ? 'width: 100px' : 'width: 100%'">
                                    <v-text-field
                                      id="inputRange2"
                                      class="range-deduction-input"
                                      append-icon="mdi-percent"
                                      outlined
                                      style="width: 100% !important"
                                      hide-details
                                      v-model="payment.discount"
                                      @keypress="isNumber($event)"
                                    ></v-text-field>
                                  </div>
                                  <v-btn
                                    v-if="payment.canDelete"
                                    icon
                                    class="bg-danger mt-1 ml-2"
                                    color="error"
                                    @click="showDeletePaymentModal(payment)"
                                  >
                                    <v-icon color="fontDefault">delete</v-icon>
                                  </v-btn>
                                </div>     
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-10">
                    <v-btn
                        class="button-shadow"
                        :class="!isOffer ? 'mr-4' : null"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(5)">
                      {{ languageData.back }}
                    </v-btn>
                    <v-btn
                        v-if="!isOffer"
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(7)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="7">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form>
                        <p class="text-h5 mb-7" style="display: flex; align-items: center">
                          {{ languageData.estimation }}
                          <span v-on:click.stop @click="openGuidesModal('makeOffer')" class="guides-question-mark" style="padding-left: 1px">?</span>
                        </p>
                        <v-btn @click="showEstimationModal" class="mr-2 mb-3" color="primary">{{ languageData.labels.addEstimation }}</v-btn>
                        <EstimatePreview :vatSettlement="data.vat_settlement" :estimateData="estimateData"></EstimatePreview>

                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-10">
                    <v-btn
                        class="button-shadow"
                        :class="layout === 'edit' ? 'mr-4' : null"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(6)">
                      {{ languageData.back }}
                    </v-btn>
                    <v-btn
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        v-if="layout === 'edit'"
                        @click="setStep(8)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content v-if="layout === 'edit'" step="8">
                <p class="text-h5 mb-7">{{ languageData.sectionProject.notes }}</p>
                <Notes noteableType="project"></Notes>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(7)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(9)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="9">
                <Documents v-if="$route.name === 'ProjectsEdit'" :projectClients="data.clients" documentableType="project" :diskUsage="data.diskUsage"></Documents>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(8)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(10)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="10">
                <p class="text-h5 mb-7">{{ languageData.sectionProject.tasks }}</p>
                <ProjectTasks></ProjectTasks>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(9)">
                    {{ languageData.back }}
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-card>
                <v-row justify="center" style="padding: 0 24px">
                  <v-col cols="12">
                    <div class="d-flex justify-end">
                      <template v-if="!isOffer">
                        <v-btn
                            class="button-shadow mb-5"
                            color="primary"
                            style="padding-left: 25px !important; padding-right: 25px !important"
                            height="55px"
                            :loading="dataSaveIsFetching || isFetchingUpdate"
                            @click="saveProject">{{ languageData.btnSaveText }}</v-btn>
                      </template>
                      <template v-else>
                        <v-btn
                            class="button-shadow mb-5"
                            color="primary"
                            style="padding-left: 25px !important; padding-right: 25px !important"
                            height="55px"
                            :loading="dataSaveIsFetching || isFetchingUpdate"
                            @click="saveOfferProject">{{ languageData.btnSaveText }}</v-btn>
                      </template>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <ProjectRelations v-if="layout === 'edit'"></ProjectRelations>
    <ModalInfo :typeInfo="layout === 'add' ? typeInfoProjectSave : typeInfoProjectUpdate" :headModal="layout === 'add' ? headInfoProjectSave : headInfoProjectUpdate" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="layout === 'add' ? isProjectSave : isProjectUpdate" :text-modal="layout === 'add' ? textInfoProjectSave : textInfoProjectUpdate"></ModalInfo>
    <ModalInfo :layout="'modalClientForm'" :hidden-agree-btn="true" @clicked="hideModalAddClientForm" :show-modal="isAddClientForm">
      <template v-slot:body>
        <ClientsForm :layout="'projectForm'"></ClientsForm>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalAddClient" :show-modal="isAddClient">
      <template v-slot:body>
        <ClientsTableSelect :deletedId="deletedId" :selectedId="selectedId" :layout="'selectClient'"></ClientsTableSelect>
      </template>
    </ModalInfo>
    <ModalInfo @doOperation="deleteDeduction" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="'info'" :headModal="modalDeleteData.languageData.head" :btnDisAgreeText="modalDeleteData.languageData.btnDisAgreeText" :btnAgreeText="modalDeleteData.languageData.btnAgreeText" :vis-agree-btn="true" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteDeductionModalInfo" :text-modal="modalDeleteData.languageData.textInfo"></ModalInfo>
    <ModalInfo
        @doOperation="deletePayment"
        :isLoadingBtn="false"
        :idData="modalDeletePaymentData.idData"
        :typeInfo="'info'"
        :headModal="modalDeletePaymentData.languageData.head"
        :btnDisAgreeText="modalDeletePaymentData.languageData.btnDisAgreeText"
        :btnAgreeText="modalDeletePaymentData.languageData.btnAgreeText"
        :vis-agree-btn="true" :visDisAgreeBtn="true" @clicked="hideModalDeletePayment"
        :show-modal="isShowDeletePaymentModal"
        :text-modal="modalDeletePaymentData.languageData.textInfo"></ModalInfo>
    <ModalInfo  :typeInfo="modalSaveInfoData.typeInfo" :headModal="modalSaveInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalSaveInfo" :show-modal="isShowSaveModalInfo" :text-modal="modalSaveInfoData.textInfo"></ModalInfo>
    <ModalInfo :key="modalDataPerson.key" :typeInfo="modalDataPerson.typeInfoPersonSave || typeInfoClientSave" :headModal="modalDataPerson.headInfoPersonSave || headInfoClientSave" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModalSaveClient" :show-modal="modalDataPerson.isPersonSave || isClientSave" :text-modal="modalDataPerson.textInfoPersonSave || textInfoClientSave"></ModalInfo>
    <ProjectOperations :project="dataReceive" v-if="this.layout === 'edit'"></ProjectOperations>
    <ModalInfo :layout="'modalSelectTable'" @clicked="hideOffersList" :hidden-agree-btn="true" :show-modal="isShowOffersListModal">
      <template v-slot:body>
        <ListOffers :layout="'projectForm'"></ListOffers>
      </template>
    </ModalInfo>
    <ModalInfo v-if="layout !== 'edit'" :scrollable="true" :layout="'modalEstimate'" :hidden-agree-btn="true" @clicked="hideModalEstimation" :show-modal="isShowEstimationModal">
      <template v-slot:body>
        <Estimate :vatSettlement="data.vat_settlement" isProjectForm :data="estimateData" :key="'projectForm'"></Estimate>
      </template>
      <template v-slot:actions v-if="languageData.labels">
        <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-wrap justify-center' : null">
          <v-btn
              color="primary"
              @click="saveEstimateEvent">
            {{ languageData.labels.save_estimation }}
          </v-btn>
        </div>
      </template>
    </ModalInfo>
  </v-container>
</template>

<style src="./ProjectsForm.scss" lang="scss"></style>

<script type="text/javascript">
import ProjectRelations from "../ProjectRelations/ProjectRelations";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import ClientsForm from "../../../Clients/components/ClientsForm/ClientsForm";
import ClientsTableForm from "../ClientsTableForm/ClientsTableForm";
import ClientsTableSelect from "../ClientsTableSelect/ClientsTableSelect";
import vatSettlement from "../../enums/VatSettlement";
import hexColorGenerator from "../../../../helpers/hexColorGenerator";
import Notes from "../../../Notes/components/Notes";
import Documents from "../../../Documents/components/Documents/Documents";
import ProjectOperations from "../ProjectOperations/ProjectOperations";
import downloadFileHelper from "../../../../helpers/downloadFileHelper";
import ClientsTableStatic from "../../../Clients/components/ClientsTableStatic/ClientsTableStatic";
import ProjectTasks from "../../../ProjectTasks/components/ProjectTaks.vue";
import ListOffers from "../../../Offers/components/ListOffers/ListOffers";
import Estimate from "../../../Estimate/components/Estimate/Estimate";
import EstimatePreview from "../../../Estimate/components/EstimatePreview/EstimatePreview";
import invoiceTypeEnum from "../../../Invoices/enums/invoiceTypeEnum";
import BackButton from "../../../../components/Global/BackButton";

  export default {
    name: "ProjectsForm",
    props: {
      layout: String,
      isOffer: Boolean,
      offerData: Object
    },
    components: {
      BackButton,
      ListOffers,
      ClientsTableStatic,
      ClientsTableForm,
      ClientsForm,
      ModalInfo,
      ClientsTableSelect,
      Notes,
      Documents,
      ProjectOperations,
      ProjectRelations,
      Estimate,
      EstimatePreview,
      ProjectTasks,
    },
    data() {
      return {
        e1: 1,
        validP: false,
        validR: false,
        validS: false,
        validT: false,
        validU: false,
        validW: false,
        validZ: false,
        data: {
          address: {},
          clients: [],
          employee_hour: null,
          varranty_deposit_az: 0.00,
          varranty_deposit_fa: 0.00,
          deductions: [],
        },
        modalDeleteData: {
          idData: 0,
          languageData: {}
        },
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          corner: 'right',
          timeout: 7500,
          title: null,
          visible: false
        },
        menuStart: false,
        activePickerStart: null,
        menuEnd: false,
        activePickerEnd: null,
        rules: {},
        vatsSettlement: vatSettlement,
        isVatPayer: localStorage.getItem("companyIsVatPayer"),
        client: {
          value: null
        },
        footerOptions: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPage: 1,
        isAddClient: false,
        clients: [],
        selectedId: [],
        selected: [],
        isAddClientForm: false,
        clientsData: [],
        deletedId: [],
        modalSaveInfoData: {},
        isShowSaveModalInfo: false,
        isShowDeleteDeductionModalInfo: false,
        minVarranty: 0,
        maxVarranty: 100,
        componentKey: 1,
        componentKeySecond: 1,
        modalDataPerson: {
          typeInfoPersonSave: "",
          headInfoPersonSave: "",
          isPersonSave: false,
          textInfoPersonSave: "",
          key: 1
        },
        isShowOffersListModal: false,
        disableCreateMeasurement: true,
        estimateData: null,
        invoicePaymentsData: [],
        invoiceTypeEnum: invoiceTypeEnum,
        invoiceTypes: [],
        isShowDeletePaymentModal: false,
        modalDeletePaymentData: {
          idData: 0,
          languageData: {}
        },
        daysArray: [],
        paymentsToDelete: [],
      }
    },
    computed: {
      ...mapState("getProjects", {
        projects: state => state.dataReceive,
      }),
      ...mapState("saveProject", {
        dataSaveIsFetching: state => state.dataSaveIsFetching,
        typeInfoProjectSave: state => state.typeInfoProjectSave,
        headInfoProjectSave: state => state.headInfoProjectSave,
        isProjectSave: state => state.isProjectSave,
        textInfoProjectSave: state => state.textInfoProjectSave
      }),
      ...mapState("updateProject", {
        dataUpdateIsFetching: state => state.dataUpdateIsFetching,
        typeInfoProjectUpdate: state => state.typeInfoProjectUpdate,
        headInfoProjectUpdate: state => state.headInfoProjectUpdate,
        isProjectUpdate: state => state.isProjectUpdate,
        textInfoProjectUpdate: state => state.textInfoProjectUpdate
      }),
      ...mapState("getProject", {
        dataReceive: state => state.dataReceive
      }),
      ...mapState("updateProject", {
        isFetchingUpdate: state => state.isFetchingUpdate
      }),
      ...mapState("getClients", {
        headers: state => state.headers
      }),
      ...mapState("saveClient", {
        typeInfoClientSave: state => state.typeInfoClientSave,
        headInfoClientSave: state => state.headInfoClientSave,
        isClientSave: state => state.isClientSave,
        textInfoClientSave: state => state.textInfoClientSave,
      }),
      ...mapState("saveClientPerson", {
        typeInfoPersonSave: state => state.typeInfoPersonUpdate,
        headInfoPersonSave: state => state.headInfoPersonUpdate,
        textInfoPersonSave: state => state.textInfoPersonUpdate,
        isPersonSave: state => state.isPersonSave,
      }),
      ...mapState("showEstimationModal", {
        isShowEstimationModal: state => state.isShowEstimationModal,
      }),
      ...mapState("getEstimate", {
        estimationsData: state => state.estimationsData
      }),
      ...mapState("updateClient", {
        isClientUpdate: state => state.isClientUpdate,
        dataUpdateIsFetching: state => state.dataUpdateIsFetching,
        typeInfoClientUpdate: state => state.typeInfoClientUpdate,
        headInfoClientUpdate: state => state.headInfoClientUpdate,
        textInfoClientUpdate: state => state.textInfoClientUpdate
      }),
      ...mapState("preventDataLost", {
        isDataChanged: state => state.isDataChanged,
      }),
      ...mapState("getCountries", {
        countries: state => state.countries,
      })
    },
    watch: {
      "data.start_date": {
        handler: function(newValue, oldValue) {
          if (newValue !== oldValue && oldValue !== undefined) {
            this.handleEventListenerOnInputs()
          }
        }
      },
      "data.end_date": {
        handler: function(newValue, oldValue) {
          if (newValue !== oldValue && oldValue !== undefined) {
            this.handleEventListenerOnInputs()
          }
        }
      },
      "data.vat_settlement": {
        handler: function(newValue, oldValue) {
          if (newValue !== oldValue && oldValue !== undefined) {
            this.handleEventListenerOnInputs()
          }
        }
      },
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
      validP: function() {
        this.isValidP();
      },
      validR: function() {
        this.isValidR();
      },
      validS: function() {
        this.isValidS();
      },
      validU: function() {
        this.isValidU();
      },
      validW: function() {
        this.isValidW();
      },
    },
    methods: {
      ...mapActions("saveProject", ["storeProject", "updateVisibleModal"]),
      ...mapActions("getProject", ["getProject", "resetProjectData"]),
      ...mapActions("updateProject", ["updateProject", "updateVisibleModalUpdate"]),
      ...mapActions("getClients", ["getHeadersTable"]),
      ...mapActions("saveClient", ["updateVisibleModalClient"]),
      ...mapActions("getHeadersDocuments", ["getHeadersDocuments"]),
      ...mapActions("getHeadersInvoiceItems", ["getHeadersInvoiceItems"]),
      ...mapActions("showEstimationModal", ["updateVisibleEstimationModal", "updateIsMeasurementState", "updateMeasurementEditId", "updateIsProjectForm"]),
      ...mapActions("updateVisibleCreateTimeReportModal", ["updateVisibleCreateTimeReportModal"]),
      ...mapActions("updateVisibleCreateInvoiceModal", ["updateVisibleCreateInvoiceModal"]),
      ...mapActions("getRecipients", ["getRecipients"]),
      ...mapActions("getInvoiceNumber", ["getInvoiceNumber"]),
      ...mapActions("generateProjectReportPdf", ["generateProjectReport"]),
      ...mapActions("getEstimate", ["getEstimate"]),
      ...mapActions("getOffers", ["getOffers"]),
      ...mapActions("importEstimation", ["importEstimation"]),
      ...mapActions("getVat", ["getVat"]),
      ...mapActions("getMeasurements", ["getMeasurements"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
      ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),
      ...mapActions("getLatestMeasurement", ["getLatestMeasurement"]),
      ...mapActions("getInvoicePaymentItems", ["getInvoicePaymentItemsRequest"]),
      ...mapActions("getCountries", ["getCountriesRequest"]),

      handleEventListenerOnInputs() {
        if (!this.isDataChanged && !this.isProjectSave && !this.isProjectUpdate) {
          this.updateDataInFormIsChanged(true);
        }
      },
      handleForm(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.addEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },
      removeEventListeners(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.removeEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },
      showEstimationModal: function() {
        this.updateVisibleEstimationModal(true);
        this.updateIsMeasurementState(false);
        this.updateMeasurementEditId(null);
      },
      hideModalEstimation() {
        this.updateVisibleEstimationModal(false);
      },
      addCategoryEvent() {
        eventBus.$emit('addCategory');
      },
      saveEstimateEvent() {
        eventBus.$emit('saveProjectEstimate');
      },
      hideModalDelete: function() {
        this.isShowDeleteDeductionModalInfo = false;
      },
      createTimeReport: function() {
        this.updateVisibleCreateTimeReportModal(true);
      },
      createInvoice: function() {
        this.getRecipients();
        this.updateVisibleCreateInvoiceModal(true);
      },
      createMeasurement() {
        this.getLatestMeasurement();
        this.updateIsProjectForm(true)
        this.updateVisibleEstimationModal(true);
        this.updateIsMeasurementState(true);
        this.updateMeasurementEditId(null);
      },
      hideModalCreateInvoice: function() {
        this.updateVisibleCreateInvoiceModal(false);
      },
      downloadInvoicePdf: function(result) {
        downloadFileHelper(result);
      },
      hideModalSaveClient: function() {
        this.modalDataPerson.isPersonSave = false;
        this.updateVisibleModalClient(false);
      },
      setNetPositive: function() {
        if (this.data.net_value < 0) {
          this.data.net_value = 0;
        }
      },
      hideModalSaveInfo: function() {
        this.isShowSaveModalInfo = false;
      },
      hideModalAddClient: function() {
        this.isAddClient = false;
      },
      hideModalAddClientForm: function() {
        this.isAddClientForm = false;
      },
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || charCode === 45 || charCode === 44) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      correctValue: function() {
        this.componentKey+=1;
        this.componentKeySecond+=1;
      },
      fixedValue: function(value) {
        if(value === 1) {
          this.data.employee_hour = this.data.employee_hour < 0 ? 0 : parseFloat(this.data.employee_hour).toFixed(2);
        }
      },
      getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      getSnackbarFailure: function(title, message) {
        this.snackbar = {
          color: "error",
          icon: "error",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      saveProject: function() {
        this.data.hexColor = hexColorGenerator();
        this.data.language = localStorage.getItem("language");
        this.data.clientItems = this.selectedId;
        
        const vatSettlement = this.data.vat_settlement ? typeof(this.data.vat_settlement) === 'object' ? this.data.vat_settlement.value : this.data.vat_settlement : null;
        
        if (vatSettlement) {
          this.data.vat_settlement = vatSettlement;
        } else {
          delete this.data.vat_settlement
        }
        
        this.rules = [];
        this.$refs.formP.resetValidation();
        this.$refs.formR.resetValidation();
        this.$refs.formS.resetValidation();
        this.data.estimateData = this.estimateData;
        this.data.invoicePayments = this.invoicePaymentsData;
        this.updateDataInFormIsChanged(false);
        if(this.layout === "edit") {
          this.data.deletedId = this.deletedId;
          this.data.paymentsToDelete = this.paymentsToDelete;
          this.updateProject({creds: this.data});
        } else {
          this.storeProject({creds: this.data});
        }
      },
      saveOfferProject() {
        this.data.hexColor = hexColorGenerator();
        this.data.language = localStorage.getItem("language");
        this.data.clientItems = this.selectedId;
        
        const vatSettlement = this.data.vat_settlement ? typeof(this.data.vat_settlement) === 'object' ? this.data.vat_settlement.value : this.data.vat_settlement : null;
        
        if (vatSettlement) {
          this.data.vat_settlement = vatSettlement;
        } else {
          delete this.data.vat_settlement
        }

        this.rules = [];
        this.$refs.formP.resetValidation();
        this.$refs.formR.resetValidation();
        this.$refs.formS.resetValidation();
        this.data.invoicePayments = this.invoicePaymentsData;

        this.data.clientItems = this.offerData.clientsTypes
        let data = this.data
        eventBus.$emit('acceptProjectOffer', data);
      },
      setStep: function(step) {
        this.e1 = step;
        if (this.$refs.lastStep) this.$vuetify.goTo(this.$refs.lastStep);
      },
      saveEnd (date) {
        this.$refs.menuEnd.save(date)
      },
      saveStart (date) {
        this.$refs.menuStart.save(date)
      },
      hideModal: function() {
        if(this.layout === "edit") {
          this.updateVisibleModalUpdate(false);
        } else {
          this.updateVisibleModal(false);
        }
      },
      showAddClientForm: function() {
        this.isAddClientForm = true;
      },
      isValidP: function() {
        if(this.validP === false) {
          this.setStep(1);
        }
      },
      isValidR: function() {
        if(this.validP !== false && this.validR === false) {
          this.setStep(3);
        }
      },
      isValidS: function() {
        if(this.validP !== false && this.validR !== false && this.validS === false) {
          this.setStep(3);
        }
      },
      isValidU: function() {
        if(this.validP !== false && this.validR !== false && this.validS !== false && this.validU === false) {
          this.setStep(5);
        }
      },
      isValidW: function() {
        if(this.validP !== false && this.validR !== false && this.validS !== false && this.validU !== false && this.validW === false) {
          this.setStep(6);
        }
      },
      addDeduction: function() {
        this.handleEventListenerOnInputs();
        this.data.deductions.push({
          name: '',
          value: 0
        });
      },
      showDeleteDeductionModal: function(item) {
        this.modalDeleteData.idData  = this.data.deductions.indexOf(item);
        this.modalDeleteData.languageData = this.languageData.modalDeleteDeduction;
        this.isShowDeleteDeductionModalInfo = true;
      },
      deleteDeduction: function(value) {
        this.data.deductions.splice(value, 1);
      },
      showOffersList () {
        this.isShowOffersListModal = true;
      },
      hideOffersList () {
        this.isShowOffersListModal = false;
      },
      initInvoicePayments () {
        this.invoiceTypes = this.invoiceTypeEnum.filter(item => item.name !== 'CORRECTIVE_INVOICE');

        this.daysArray = Array.from({length: 120}, (_, i) => i + 1)
        if(this.layout !== 'edit') {
          this.invoicePaymentsData = [
            {
              days: 7,
              invoiceType: this.invoiceTypes.find(el => el.name === 'PARTIAL_INVOICE').value,
              discount: 0,
              project: null,
              canDelete: true,
            },
          ];
        }
      },
      addPayment() {
        this.invoicePaymentsData.push(
            {
              days: 0,
              invoiceType: this.invoiceTypes.find(el => el.name === 'PARTIAL_INVOICE').value,
              discount: 0,
              project: null,
              canDelete: true,
            },
        )
      },
      showDeletePaymentModal: function(item) {
        this.modalDeletePaymentData.idData  = item;
        this.modalDeletePaymentData.languageData = this.languageData.modalDeletePayment;
        this.isShowDeletePaymentModal = true;
      },
      hideModalDeletePayment: function() {
        this.isShowDeletePaymentModal = false;
      },
      deletePayment: function(value) {
        this.invoicePaymentsData.splice(this.invoicePaymentsData.indexOf(value), 1);
        if('id' in value) {
          this.paymentsToDelete.push(value);
        }
      },
     openGuidesModal(guideKey) {
        this.updateGuidesModalVisible({
          isGuidesModalVisible: true,
          guideKey
        });
      },
    },
    beforeMount() {
      this.isVatPayer = localStorage.getItem("companyIsVatPayer");
    },
    mounted() {
      this.updateLanguage(this.getCurrentLanguage);
      const language = this.getCurrentLanguage;
      this.getHeadersTable({creds: {language}});

      if(this.layout === 'edit') {
        this.getVat();
        this.getEstimate({id: null});
      }

      this.getCountriesRequest();
      this.initInvoicePayments();

      eventBus.$on("showSnackbarSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });
      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      });

      if(this.layout === "edit") {
        this.getProject();
      }

      eventBus.$on('refreshProjectData', () => {
        this.getProject();
        this.getInvoicePaymentItemsRequest();
      });
      eventBus.$on("storeClientSuccess", () => {
        this.modalDataPerson.key += 1;
      });

      eventBus.$on("setProjectFormData", () => {
        this.data = this.dataReceive;
        this.selected = this.dataReceive.clients;
        this.dataReceive.clientsId.filter((item) => {
          if(item === this.dataReceive.clientsTypes[this.dataReceive.clientsId.indexOf(item)]["client_id"]) {
            this.selectedId.push(
                {
                  id: this.dataReceive.clientsTypes[this.dataReceive.clientsId.indexOf(item)]["client_id"],
                  clientType: this.dataReceive.clientsTypes[this.dataReceive.clientsId.indexOf(item)]["client_type"]
                }
            );
          }
        });
        this.invoicePaymentsData = this.dataReceive.invoicePayments;
        this.disableCreateMeasurement = !this.dataReceive.hasEstimation;
        eventBus.$emit("selectedClient", this.selectedId);
      });

      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersTable({creds: {language}});
        this.getCountriesRequest();
      });

      eventBus.$on("saveProjectFailure", (errorsData) => {
        this.rules = handleFormError(errorsData);
        this.validP = this.$refs.formP.validate();
        this.validR = this.$refs.formR.validate();
        this.validS = this.$refs.formS.validate();
        this.validU = this.$refs.formU.validate();
        this.isValidP();
        this.isValidR();
        this.isValidS();
        this.isValidU();

      });

      eventBus.$on("acceptOfferFailure", (errorsData) => {
        this.rules = handleFormError(errorsData);
        this.validP = this.$refs.formP.validate();
        this.validR = this.$refs.formR.validate();
        this.validS = this.$refs.formS.validate();
        this.validU = this.$refs.formU.validate();
        this.isValidP();
        this.isValidR();
        this.isValidS();
        this.isValidU();
      })

      eventBus.$on("showSelectClientModal", () => {
        this.isAddClient = true;
        eventBus.$emit("filterSelectClients");
      });

      eventBus.$on("storeClientSuccess", (clientId, data) => {
        this.isAddClientForm = false;
        this.isAddClient = false;
        this.modalSaveInfoData.typeInfo = "success";
        this.modalSaveInfoData.textInfo = data.data.textInfo;
        this.modalSaveInfoData.head = data.message;
        this.isShowSaveModalInfo = true;
      });

      eventBus.$on("showProjectForm", () => {
          this.isAddClientForm = true;
      });
      eventBus.$on("showChooseClientModal", () => {
          this.isAddClient = true;
          eventBus.$emit("filterSelectClients");
      })
      eventBus.$on("deleteClientStep", (index, id) => {
        this.deletedId.push(id);
        this.selectedId.splice(this.selectedId.findIndex(item => item.id === id), 1);
        eventBus.$emit('enableToSelectClient', id);
        this.handleEventListenerOnInputs();
      });

      eventBus.$on("addClientSelect", (item) => {
        this.selectedId.push({
          id: item.id,
          clientType: 1
        });
      });

      eventBus.$on("showFailurePerson", (data) => {
        this.modalDataPerson = data;
      });

      eventBus.$on("generateProjectReportPdfSuccess", (data) => {
        downloadFileHelper(data);
        this.getSnackbarSuccess(data.message, data.data.textInfo, "check_circle", "success");
        this.setStep(9);
        eventBus.$emit("filterDocuments");

      });

      eventBus.$on("generateEstimationPdfSuccess", (data) => {
        downloadFileHelper(data);
        this.getSnackbarSuccess(data.message, data.data.textInfo, "check_circle", "success");
        this.setStep(9);
        eventBus.$emit("filterDocuments");
      });

       eventBus.$on("generateEstimationPdfFailure", (data) => {
        this.getSnackbarFailure(data.message, data.data.textInfo, "check_circle", "error");
      });


      eventBus.$on("deletePlannedContactSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });

      eventBus.$on("savePlannedContactSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });

      eventBus.$on("updatePlannedContactSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      });

      eventBus.$on("updateProjectSuccess", () => {
        this.getProject();
      });

      eventBus.$on("saveOrUpdateProjectEntrySuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.text);
      });

      eventBus.$on('saveProjectSuccess', () => {
        this.updateDataInFormIsChanged(false);
      });

      eventBus.$on("prepareClientForProject", (data) => {
        this.data = data
        this.selected = data.clients;
        data.clientsId.filter((item) => {
          if(item === data.clientsTypes[data.clientsId.indexOf(item)]["client_id"]) {
            this.selectedId.push(
                {
                  id: data.clientsTypes[data.clientsId.indexOf(item)]["client_id"],
                  clientType: data.clientsTypes[data.clientsId.indexOf(item)]["client_type"]
                }
            );
          }
        });
      });

      eventBus.$on("importEstimation", (item) => {
        let creds = {
          offer_id: item.id,
        }
        this.importEstimation({creds: creds})
      });
      eventBus.$on('importEstimationSuccess', (dataReceive) => {
        this.getEstimate({id: null});
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
        this.disableCreateMeasurement = false;
        this.handleEventListenerOnInputs();
        this.updateVisibleEstimationModal(false);
        this.isShowOffersListModal = false;

      });

      eventBus.$on('enableCreateMeasurement', () => {
        this.disableCreateMeasurement = false;
      })

      eventBus.$on("projectEstimatePrepare", (estimate) => {
        this.hideModalEstimation(true);
        this.data.estimateData = estimate;
        this.estimateData = estimate;
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          position: "top",
          corner: 'right',
          title: this.languageData.estimateAdded,
          visible: true
        };
        this.handleEventListenerOnInputs();
      });
      eventBus.$on("getEstimateSuccess", () => {
        this.estimateData = this.estimationsData
        eventBus.$emit('assignVatEstimate');
      });
      eventBus.$on("updateClientSuccessForSnackbar", (data) => {
        this.getSnackbarSuccess(data.message, data.data.textInfo);
      }),
      eventBus.$on("sendInvoiceSuccess", (snackbarData) => {
      this.getSnackbarSuccess(snackbarData.title, snackbarData.message, "check_circle", "success");
      });
      eventBus.$on('getLatestMeasurementIdSuccess', (measurementId) => {    
        if (measurementId) {
          this.getEstimate({id: null, measurementId: measurementId, toCreate: true}); 
        } else {
          this.getEstimate({id: null});
        }
        
      });
      eventBus.$on('openOfferListModal', () => {
        this.isShowOffersListModal = true;
      });
      eventBus.$on('confirmTimeReportSummarySuccess', () => {
        if (this.$route.name === 'ProjectsEdit') {
          this.getProject();
        }
      })
    },
    beforeDestroy() {
      eventBus.$off('storeClientSuccess');
      eventBus.$off('updateProjectSuccess');
      eventBus.$off('importEstimationSuccess')
      eventBus.$off('saveEstimateSuccess')
      eventBus.$off('generateEstimationPdfSuccess')
      eventBus.$off('generateProjectReportPdfSuccess')
      eventBus.$off('enableCreateMeasurement')
      eventBus.$off('getLatestMeasurementIdSuccess')
      eventBus.$off('setProjectFormData');
      this.resetProjectData();
      this.removeEventListeners('formP');
      this.removeEventListeners('formR');
      this.removeEventListeners('formS');
      this.removeEventListeners('formU');
    },
  }
</script>
